import { render, staticRenderFns } from "./BrowserNotSupported.vue?vue&type=template&id=2ae50232&scoped=true"
import script from "./BrowserNotSupported.vue?vue&type=script&lang=js"
export * from "./BrowserNotSupported.vue?vue&type=script&lang=js"
import style0 from "./BrowserNotSupported.vue?vue&type=style&index=0&id=2ae50232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae50232",
  null
  
)

export default component.exports